import { useMutation } from "@tanstack/react-query";
import { apiV1 } from "api-v2";
import type { VerifyCodeResponse } from "newui/features/Auth/types/userInvite";

interface VerifyCodePayload {
  token: string;
  code: string;
}

interface VerifyCodeError {
  message: string;
  code?: string;
  errors?: { attempts_remaining?: number; locked_until?: string };
}

export const useVerifyCodeMutation = () =>
  useMutation<VerifyCodeResponse, VerifyCodeError, VerifyCodePayload>({
    mutationFn: async (payload) => {
      const res = await apiV1.post<VerifyCodeResponse>(
        "auth/invite/verify-code",
        payload
      );
      return res.data;
    },
    retry: false,
  });
